import {
  PressReleaseWrapper,
  TitleWrapper,
  BodyTextWrapper,
  DateWrapper,
  PressReleaseFooter,
} from './style';
import { Button } from '@components/Button';
import { Dates } from '@components/Dates';
import { FC } from 'react';

export interface PressReleaseCardProps {
  title?: string;
  bodyText?: string;
  date?: string;
  url?: string;
  locale?: string;
  backgroundColor?: boolean;
}

export const PressReleaseCard: FC<PressReleaseCardProps> = ({
  title,
  bodyText,
  date,
  url,
  locale,
  backgroundColor, // backgroundColor is a boolean to determine if the card is on top of a background color or not
}) => {
  return (
    <PressReleaseWrapper $backgroundColor={backgroundColor}>
      {title && (
        <TitleWrapper>
          <h3>{title}</h3>
        </TitleWrapper>
      )}

      {bodyText && <BodyTextWrapper>{bodyText as string}</BodyTextWrapper>}
      {(date || url) && (
        <PressReleaseFooter>
          {date && ( // This may need to be changed to @Components/Dates when correct data is added
            <DateWrapper>
              <Dates startDate={date} locale={locale} />
            </DateWrapper>
          )}
          {url && <Button variant="tertiary" url={url} label="Read More" arrow={true} />}
        </PressReleaseFooter>
      )}
    </PressReleaseWrapper>
  );
};

export default PressReleaseCard;
